<template>
    <div>

        <div style="" class="leftTitle mt-3 clearfix ">
            <!--Záujmy-->
            <li><span class="interes">{{$t("hobbies.1")}}</span>:</li>
        </div>
        <div style="" class="mt-2 clearfix">
            <div style="" class="infoLine mt-1 clearfix">
                <i class="fas fa-code iconBlack"></i>
                <!--Písanie kódu-->
                <span class="info coding">{{$t("hobbies.2")}}</span>
            </div>
            <div style="" class="infoLine mt-1 clearfix">
                <i class="fas fa-walking iconBlack"></i>
                <!--Turistika-->
                <span class="info tourism ">{{$t("hobbies.3")}}</span>
            </div>

            <div style="" class="infoLine mt-1 clearfix">
                <i class="fas fa-balance-scale iconBlack"></i>
                <!--Pozemkové právo-->
                <span class="info law ">{{$t("hobbies.4")}}</span>
            </div>
            
            <div style="" class="infoLine mt-1 clearfix">
                <i class="fas fa-music iconBlack"></i>
                <!--Hudba-->
                <span class="info music ">{{$t("hobbies.5")}}</span>
            </div>
            
            <div style="" class="infoLine mt-1 clearfix">
                <i class="fas fa-pencil-alt iconBlack"></i>
                <!--Texty pre hudbu-->
                <span class="info musicTexts ">{{$t("hobbies.6")}}</span>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>